import styled from "@emotion/styled";
import { Alert } from "@mui/material";
import { styled as muistyled } from "@mui/system";
import { globalColors } from "../../../Utils/colors";
import { ReactComponent as CloseIconSvg } from "../../../assets/PopupCloseIcon.svg";
import { ReactComponent as UploadImageIconSvg } from "../../../assets/uploadImageIcon.svg";

export const HeaderContainer = styled.div`
  align-items: center;
  color: ${globalColors.logoBackground};
  font-weight: "600";
  display: flex;
  justify-content: space-between;
`;

export const ActionsContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  height: 100%;
  margin-top: 5px;
  width: 100%;
`;

export const PopupCloseIconComponent = () => {
  return (
    <CloseIconSvg
      style={{ height: 24, width: 24, fill: globalColors.logoBackground }}
    />
  );
};

export const UploadImageIconComponent = () => {
  return <UploadImageIconSvg />;
};

export const UploaderImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const UploaderTextContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  text-align: center;
  color: ${globalColors.logoBackground};
  font-size: 18px;
  font-family: "Poppins";
  text-wrap: nowrap;
  cursor: pointer;
`;

export const UploaderSubTextContainer = styled.div`
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  text-align: center;
  color: ${globalColors.logoBackground};
  font-size: 12px;
  font-family: "Poppins";
  text-wrap: nowrap;
  cursor: pointer;
`;

export const StyledMuiAlert = muistyled(Alert)({
  marginTop: 20,
});

export const PublishModalLinkContainer = muistyled("div")({
  height: "80px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Poppins",
  fontSize: "16px",
  textAlign: "center",
});

export const PublishModalMessageContainer = muistyled("div")({
  height: "80px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Poppins",
  fontSize: "14px",
  color: "gray",
});

export const PublishModalButtonContainer = muistyled("div")({
  display: "flex",
  height: "40px",
  width: "100%",
  alignItems: "center",
  justifyContent: "flex-end",
});

export const LogicTabRootContainer = styled.div`
  height: 100vh;
`;

export const LogicTabHeaderContainer = styled.div`
  height: 60px;
`;

export const LogicTabBodyContainer = styled.div`
  display: flex;
  height: calc(100% - 65px);
`;

export const LogicTabSidebarContainer = styled.div<any>`
  border-right: 1px solid lightgray;
  height: 100%;
  width: ${(props) => {
    return props.isExpanded ? "300px" : "0px";
  }};
  margin-right: 10px;
`;

export const LogicTabSidebarHeader = styled.div`
  height: 40px;
  padding: 10px 12px;
  font-size: 16px;
  font-family: Poppins;
  font-weight: 600;
`;

export const LogicTabSidebarContent = styled.div`
  height: calc(100% - 120px);
  padding: 10px 12px;
  font-size: 14px;
  font-family: Poppins;
  overflow-y: auto;
`;

export const LogicTabSidebarActions = styled.div`
  height: 40px;
  padding: 0px 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
`;

export const LogicTabContentContainer = styled.div<any>`
  height: 100%;
  width: ${(props) => {
    return props.isExpanded ? "calc(100% - 300px)" : "100%";
  }};
`;

export const DropDownContainer = styled.div`
  margin-top: 10px;
`;

export const SpaceWrapper = styled.div`
  margin: 10px 0px;
`;
